export const formatPrice = (value) =>
  new Intl.NumberFormat('en-PK', {
    style: 'currency',
    currency: 'PKR',
    maximumFractionDigits: 0,
  })
    .format(Number(value) || 0)
    .replace('PKR', 'Rs.')
